module.exports = __webpack_public_path__ + "images/983ffdaa4585b294f6c690c9aa5e15dc.webp";